import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Form from "@Components/Form";
import ShopContact from "./ShopContact";
import eightAxios from "configs/axiosConfig";
import {
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  URLS,
  ZONE_FETCH_URL,
} from "configs/constants";

const initialValues = {
  name: "",
  image: null,
  zone_name: "",
  region_name: "",
  estate_name: "",
  free_text: "",
  active: false,
};

const ShopDetail = () => {
  const [contacts, setContacts] = useState([]);
  const params = useParams();

  useEffect(() => {
    eightAxios
      .get(`shop/${params.id}/`)
      .then((response) => {
        const contactsData = response.data.contacts;
        const modifiedContacts = contactsData.map((contact) => ({
          ...contact,
          confirmed: true,
        }));
        setContacts(modifiedContacts);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const formFields = [
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Shop Name",
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "imagerender",
      name: "image",
      label: "Image",
      key: "image",
      showText: "Shop Image",
      supportedTypes: ["png", "jpg", "jpeg"],
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone_name",
      key: "zone_name",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      paginated: true,
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region_name",
      key: "region_name",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      optionsDependsOn: "zone",
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      optionsDependsOn: "region",
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      multiline: true,
      rows: 3,
      name: "free_text",
      key: "free_text",
      label: "Free Text",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "active",
      key: "active",
      label: "Active?",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },

    { type: "title", title: "Contact Number", required: true },
    {
      type: "component",
      component: ShopContact,
      contacts: contacts,
      setContacts: setContacts,
      gridSize: { xs: 12 },
      renderOnly: true,
    },
  ];

  const formButtons = ["cancel"];
  return (
    <Form
      submitUrl="shop/"
      listRoute={URLS.KEDAI_LIST}
      initialValues={initialValues}
      formButtons={formButtons}
      formFields={formFields}
      formTitle="Contact List"
    />
  );
};

export default ShopDetail;
